import i18n from 'i18next'; import { useEffect, useMemo, useState } from 'react';
import useQuery from '../hooks/useQuery';
import { Box } from '@mui/material';
import { Typography } from '@material-ui/core';
import userService from '../services/userService';
import helpers from '../utils/helpers';
import constants from '../utils/constants';

export default function ExternalLogin() {
  const query = useQuery();
  const [error, setError] = useState(null);
  const token = useMemo(() => {
    if (!query) {
      return 'loading';
    }
    return query.get('access_token');
  }, [query]);

  useEffect(() => {
    if (!token || token === 'loading') {
      return;
    }

    const login = () => {
      userService.loginWithJwt(token).then((res) => {
        if (res) {
          if (Array.isArray(res.sectorId)) {
            res.sectorId = helpers.nameToTitle(res.sectorId);
          }
          localStorage.setItem('user', JSON.stringify(res));
          helpers.setRole(res.role?.toLowerCase() === 'seller' ? constants.role.seller : constants.role.buyer);
          if (res.isFirstLogin && !res.permissions.hasOnlyStorager) {
            window.location.href = '/account?tab=profile&edit=true';
            // navigate('/account?tab=profile&edit=true');
          } else if (res.permissions.hasOnlyStorager) {
            window.location.href = '/predemands';
            // navigate('/predemands');
          } else {
            window.location.href = '/deals';
            // navigate('/deals');
          }
        } else {
          setError('Geçersiz Token!!');
        }
      }).catch(() => {
        setError('Bir sorun oluştu');
      });
    };

    login();
  }, [token]);

  if (token === 'loading') {
    return (
      <Box sx={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
      >

        <Typography>{i18n.t('ExternalLogin.y\xFCkleniyor')}</Typography>
      </Box>
    );
  }

  if (!token || error) {
    return (
      <Box sx={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
      >

        <Typography color="red">
          {error ?? 'Hatalı Token!!'}
          {' '}
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{
      width: '100vw',
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }}
    >

      <Typography>{i18n.t('ExternalLogin.y\xF6nlendiriliyorsunuz')}</Typography>
    </Box>
  );
}
